import { FunctionComponent } from 'preact';
import { useState } from 'preact/hooks';
import { route, RoutableProps } from 'preact-router';
import { Layout } from '../components/layout';
import { captchaImageUrl, requestPasswordReset } from '../services/reset-password.service';

export const ForgotPasswordPage: FunctionComponent<RoutableProps> = () => {
  const [email, setEmail] = useState('');
  const [captcha, setCaptcha] = useState('');
  const [captchaSrc, setCaptchaSrc] = useState(captchaImageUrl());
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const reloadCaptcha = () => {
    setCaptcha('');
    setCaptchaSrc(captchaImageUrl());
  };

  const submit = async (e: Event) => {
    e.preventDefault();
    if (busy) return;

    setError(null);
    setBusy(true);

    try {
      await requestPasswordReset(email, captcha);
      route('/forgot-password/sent', true);
    } catch {
      setError('Anfrage fehlgeschlagen. Captcha falsch oder Service nicht erreichbar.');
      reloadCaptcha();
      setBusy(false);
    }
  };

  return (
    <Layout title="Passwort vergessen" subtitle="Wir schicken dir einen Link per E-Mail.">
      <form onSubmit={submit}>
        <div class="input-group">
          <label for="email">E-Mail</label>
          <input
            id="email"
            type="email"
            value={email}
            onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
            autocomplete="username"
            required
            disabled={busy}
          />
        </div>

        <div class="input-group">
          <label for="captcha">Captcha</label>
          <div class="captcha-wrap">
            <img src={captchaSrc} alt="Captcha" onClick={reloadCaptcha} />
            <button type="button" class="reload" onClick={reloadCaptcha} aria-label="Neues Captcha laden">
              {'\u21bb'}
            </button>
          </div>
          <input
            id="captcha"
            type="text"
            value={captcha}
            onInput={(e) => setCaptcha((e.target as HTMLInputElement).value)}
            autocomplete="off"
            required
            disabled={busy}
          />
        </div>

        {error && <div class="error">{error}</div>}

        <button type="submit" class="btn" disabled={busy}>
          {busy ? <span class="spinner" /> : 'Link anfordern'}
        </button>

        <div class="center mt-md">
          <a class="btn link" href="/login" onClick={(e) => { e.preventDefault(); route('/login'); }}>
            Zurück zur Anmeldung
          </a>
        </div>
      </form>
    </Layout>
  );
};
